// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => (chunkId + ".css");